import {Action} from 'redux';
import {Tempo} from '../entities';

export enum TPlayrule {
  FETCH_PLAYRULES = 'FETCH_TEMPOS',
  SET_PLAYRULES = 'SET_TEMPOS'
}

export interface IFetchPlayrules extends Action {
  type: TPlayrule.FETCH_PLAYRULES;
}

export const AFetchPlayrules = (): IFetchPlayrules => ({type: TPlayrule.FETCH_PLAYRULES});

export interface ISetPlayrules extends Action {
  type: TPlayrule.SET_PLAYRULES;
  payload: Tempo[];
}

export const ASetPlayrules = (payload: Tempo[]): ISetPlayrules => ({type: TPlayrule.SET_PLAYRULES, payload});
